module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/king-817cc36de96cf0338719b307013d05bc.svg";